import { PublicApiClient } from '@/services/PublicApiClient'

export default {
  getInvoice(orderId, tckn) {
    return PublicApiClient.post(
      'invoice/' + orderId,
      { tckn },
      {
        responseType: 'arraybuffer'
      }
    )
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  },
  getLateFeeInvoice(orderId, tckn) {
    return PublicApiClient.post(
      'late-fee-invoice/' + orderId,
      { tckn },
      {
        responseType: 'arraybuffer'
      }
    )
    .then(response => {
      let blob = new Blob([response.data], { type: 'application/pdf' })
      return window.URL.createObjectURL(blob)
    })
    .catch(err => {
      throw err
    })
  },
  getOrderReceipt(orderId, tckn) {
    return PublicApiClient.post(
      'order-receipt/' + orderId,
      { tckn },
      {
        responseType: 'arraybuffer'
      }
    )
    .then(response => {
      let blob = new Blob([response.data], { type: 'application/pdf' })
      return window.URL.createObjectURL(blob)
    })
    .catch(err => {
      throw err
    })
  },
  getOrder(orderId, tckn) {
    return PublicApiClient.post('invoice/' + orderId + '/order', { tckn })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPaidPromissoryNote(orderId, tckn) {
    return PublicApiClient.post(
      'paid-promissory-note/' + orderId,
      { tckn },
      {
        responseType: 'arraybuffer'
      }
    )
      .then(response => {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        return window.URL.createObjectURL(blob)
      })
      .catch(err => {
        throw err
      })
  }
}
